export enum TP_AMB {
    PRODUCAO = 1,
    HOMOLOGACAO = 2,
}